import { Box, Drawer } from "@mui/material";
import DialogHeader from "../dialogs/DialogHeader";

interface ICustomDrawerProps {
  drawerWidth?: number;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title: string;
  showCloseButton?: boolean;
  anchor?: "left" | "right" | "top" | "bottom";
  transitionDuration?: { enter: number; exit: number };
}

const CustomDrawer = ({
  open,
  onClose,
  children,
  title,
  showCloseButton,
  anchor = "right",
  drawerWidth = 420,
  transitionDuration = { enter: 300, exit: 200 },
}: ICustomDrawerProps) => {
  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      transitionDuration={transitionDuration}
      slotProps={{
        paper: {
          sx: {
            width: drawerWidth,
            maxWidth: "100%",
            borderRadius: 0,
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
            overflow: "hidden",
          },
        },
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <DialogHeader
          title={title}
          showCloseButton={showCloseButton}
          onClose={onClose}
        />
        <Box sx={{ pt: 2 }}>{children}</Box>
      </Box>
    </Drawer>
  );
};

export default CustomDrawer;
